var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#E6EDEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.753 27.3478C32.3343 27.3478 34.4269 25.2552 34.4269 22.6739C34.4269 20.0926 32.3343 18 29.753 18C27.1717 18 25.0791 20.0926 25.0791 22.6739C25.0791 25.2552 27.1717 27.3478 29.753 27.3478Z",
    fill: "#054940"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2082 27.348C40.84 27.348 42.1629 26.0251 42.1629 24.3932C42.1629 22.7614 40.84 21.4385 39.2082 21.4385C37.5763 21.4385 36.2534 22.7614 36.2534 24.3932C36.2534 26.0251 37.5763 27.348 39.2082 27.348Z",
    fill: "#054940"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2978 27.348C21.9296 27.348 23.2525 26.0251 23.2525 24.3932C23.2525 22.7614 21.9296 21.4385 20.2978 21.4385C18.6659 21.4385 17.343 22.7614 17.343 24.3932C17.343 26.0251 18.6659 27.348 20.2978 27.348Z",
    fill: "#054940"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2091 30.0013C22.046 29.0483 20.9926 29.1745 19.6478 29.1745C17.6364 29.1745 16 30.8012 16 32.8002V38.6673C16 39.5354 16.7086 40.2414 17.58 40.2414C21.342 40.2414 20.8888 40.3094 20.8888 40.0791C20.8888 35.9217 20.3963 32.8729 23.2091 30.0013Z",
    fill: "#054940"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0321 29.1962C28.6831 29.0003 26.6414 29.1985 24.8803 30.6521C21.9332 33.0127 22.5003 36.1911 22.5003 40.0794C22.5003 41.1081 23.3374 41.9607 24.3817 41.9607C35.7216 41.9607 36.173 42.3265 36.8454 40.8374C37.0659 40.3338 37.0055 40.4938 37.0055 35.6762C37.0055 31.8498 33.6923 29.1962 31.0321 29.1962Z",
    fill: "#054940"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8582 29.1743C38.506 29.1743 37.4584 29.0495 36.2969 30.0011C39.0886 32.8514 38.6172 35.6923 38.6172 40.079C38.6172 40.3107 38.2409 40.2412 41.8695 40.2412C42.7721 40.2412 43.5059 39.5101 43.5059 38.6113V32.8001C43.5059 30.8011 41.8695 29.1743 39.8582 29.1743Z",
    fill: "#054940"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon (1).c14443babbef26b90a7681926b00bb99.svg";
export { ForwardRef as ReactComponent };